import FamilyRecordsModule from '../components/FamilyRecordsModule'

export default function FamilyBoard(){
 return <FamilyRecordsModule module="family_posts"/>
}
